import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const BottleIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 286 467" {...props}>
    <g id="Plan_de_travail_1" data-name="Plan de travail – 1">
      <rect width="286" height="467" fill="#ffffff00" />
      <g id="noun-shampoo-3732946" transform="translate(-183.328 -46.668)">
        <path
          id="Tracé_33950"
          data-name="Tracé 33950"
          d="M417.25,65.332,451.6,123.309a9.336,9.336,0,0,0,16.063-9.52L430.6,51.243a9.334,9.334,0,0,0-8.031-4.574H231.837a9.332,9.332,0,0,0,0,18.664h29.441v63.82H248.6A26.125,26.125,0,0,0,222.5,155.246v31.926H212.012a29.186,29.186,0,0,0-29.156,29.152v267.85a29.187,29.187,0,0,0,29.156,29.156h190.73A29.186,29.186,0,0,0,431.9,484.178V417.451l0-134.4V216.324a29.186,29.186,0,0,0-29.156-29.152H392.254V155.246a26.125,26.125,0,0,0-26.094-26.094H353.48V65.328Zm-4.016,342.79H201.514V292.392h211.72Zm-10.492,86.547H212.012a10.5,10.5,0,0,1-10.492-10.488V426.786H413.24v57.395a10.5,10.5,0,0,1-10.492,10.488Zm10.492-278.34v57.395H201.514v-57.4a10.5,10.5,0,0,1,10.492-10.488h190.74a10.5,10.5,0,0,1,10.488,10.488Zm-39.648-61.074v31.926l-132.42,0V155.251a7.437,7.437,0,0,1,7.43-7.43h117.56a7.443,7.443,0,0,1,7.43,7.434Zm-38.773-26.1H279.938V65.337h54.875Z"
        />
      </g>
    </g>
  </SvgIcon>
));

export default React.memo(BottleIcon);
